import React from 'react'
import { ColumnsGroup, ColumnsType } from "../SchemaTypes/tableSchema";
import { FC, ReactElement, ReactNode } from "react";
import { cn } from '../helper/classNames';
import { Table, TablePaginationConfig, TableProps } from 'antd';


interface CustomTableProps {
  bordered?: boolean;
  headerComponent?: ReactElement;
  components?: any;
  rowClassName?: any;
  expandable?: any;
  rowKey?: string;
  data: any[];
  columns: ColumnsGroup | ColumnsType;
  rowSelection?: any;
  className?: string;
  evenRowClassName?: boolean;
  oddRowClassName?: boolean;
  scroll?: TableProps<any>["scroll"];
  pagination?: false | TablePaginationConfig | TableProps<any>["pagination"];
  loading?: boolean;
  pageSize?: number;
  caption?: string;
  rightComponent?: ReactNode;
  hideHeaders?: boolean;
  showHeader?: boolean;
  onRow?: any;
  rowHoverable?: boolean;
  summary?: TableProps<any>["summary"];
  sticky?: TableProps<any>["sticky"];
  size?: TableProps<any>["size"];
  tableLayout?: TableProps<any>["tableLayout"];
  locale?: TableProps<any>["locale"];
  onChange?: TableProps<any>["onChange"];
  footer?: TableProps<any>["footer"];
  title?: TableProps<any>["title"];
  style?: React.CSSProperties;
}

const CustomTable: FC<CustomTableProps> = (props: CustomTableProps) => {
  const {
    data,
    columns,
    bordered = true,
    components,
    rowSelection = "",
    expandable = false,
    pageSize = 50,
    rowKey = "",
    scroll = { x: true, align: "center" },
    loading = false,
    pagination = { defaultPageSize: pageSize, showSizeChanger: true, size: "small", alignmentBottom: "center" },
    caption = "",
    rowClassName,
    rightComponent = <></>,
    className,
    hideHeaders = false,
    showHeader = true,
    onRow = undefined,
    rowHoverable = true,
    summary,
    sticky = false,
    size = "small",
    tableLayout = sticky ? "fixed" : "auto",
    locale,
    onChange,
    footer,
    title,
    style,
  } = props;


  return (
    <div>
      <div className={cn("flex justify-between items-center", !caption && "flex-row-reverse")}>
        {!!caption && <h4 className="sub-headline">{caption}</h4>}
        {rightComponent}
      </div>
      <Table rowHoverable={rowHoverable}
        dataSource={data}
        scroll={scroll}
        columns={columns}
        pagination={pagination}
        rowSelection={rowSelection ? { ...rowSelection } : null}
        bordered={bordered}
        showHeader={showHeader}
        showSorterTooltip={false}
        components={components}
        rowClassName={rowClassName ? rowClassName : (record: any) => data.indexOf(record) % 2 ? "bg-neutral" : "bg-primary-white"}
        expandable={expandable}
        rowKey={rowKey}
        size={size}
        loading={loading}
        className={cn(className, hideHeaders && "hide-headers", rowHoverable && "cursor-pointer")}
        onRow={onRow}
        summary={summary}
        sticky={sticky}
        tableLayout={tableLayout}
        locale={locale}
        onChange={onChange}
        footer={footer}
        title={title}
        style={style}
      />
    </div>
  );
};

export default CustomTable;
